import React, { useState } from 'react'
import logo from '../Assests/isecurion1.png';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { useEffect } from 'react';
import "./css/UpdateUser.css";
import "./css/LoginPage.css";
import updateIllustration from '../Assests/Update Illustration.png'
import bugtrack from '../Assests/Frame 495.png'
import { Icon } from '@iconify/react';
import { url } from '../constants/url';


function UpdateUser() {

    const { token } = useParams()
    const [passwordVisible2, setPasswordVisible2] = useState(false);
    const [passwordVisible1, setPasswordVisible1] = useState(false);

    const [newPassword, setNewPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [isValid, setIsValid] = useState(null);
    const navigate = useNavigate('')

    const [newPasswordError, setNewPasswordError] = useState('')
    const [confirmPasswordError, setConfirmPasswordError] = useState('')
    const [passwordVisible, setPasswordVisible] = useState(false);

    const specialChars = /[!@#$%^&*(),.?":{}|<>]/;


    const togglePasswordVisibility1 = () => {
        setPasswordVisible1(!passwordVisible1);
    };
    const togglePasswordVisibility2 = () => {
        setPasswordVisible2(!passwordVisible2);
    };


    // Refer users.js file for backend code
    const handlePassword = async () => {
        if (newPassword === '') {
            setNewPasswordError("Password required")
            return
        }
        if (confirmPassword === '') {
            setConfirmPasswordError('Confirm password required')
            return
        }
        if (newPassword !== confirmPassword) {
            setConfirmPasswordError('Passwords do not match')
            return
        }
        if (newPassword.length < 8) {
            setNewPasswordError('Password should be a minimum of 8 character');
            return;
        }
        if (!specialChars.test(newPassword)) {
            setNewPasswordError('Password should include at least one special character');
            return;
        }
        if (!/[A-Z]/.test(newPassword)) {
            setNewPasswordError('Password should include at least one capital alphabet');
            return;
        }
        try {
            const response = await fetch(`${url}/updateloginpassword?token=${token}`, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    newPassword,
                    confirmPassword
                })
            })
            if (response.status === 200) {
                setNewPassword('')
                setConfirmPassword('')
                navigate('/')
                toast.success("Password updated successfully. Please login again.", {
                    position: "top-right",
                    autoClose: 2500,
                    pauseOnHover: false,
                })
                return
            }
            if (response.status === 400) {
                toast.error("Something went wrong", {
                    position: "top-right",
                    autoClose: 2500,
                    pauseOnHover: false,
                })
                return
            }
            if (response.status === 406) {
                toast.error("Something went wrong", {
                    position: "top-right",
                    autoClose: 2500,
                    pauseOnHover: false,
                })
                return
            }
            if (response.status === 403) {
                toast.error("New password must be different from the one-time password.", {
                    position: "top-right",
                    autoClose: 2500,
                    pauseOnHover: false,
                })
                return
            }
        } catch (error) {
            console.log(error)
        }
    }

    // Refer users.js file for backend code
    const verifyUpdatePassword = async () => {
        try {
            const response = await fetch(`${url}/verifyupdateloginlink?token=${token}`, {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json'
                },
            })
            if (response.status === 200) {
                setIsValid(true);
            } else {
                setIsValid(false);
                toast.error("Something went wrong", {
                    position: "top-right",
                    autoClose: 2500,
                    pauseOnHover: false,
                })
                setTimeout(() => {
                    navigate("/login")
                }, 500000)
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        verifyUpdatePassword()
    }, [])

    return (
        <div className="wrap_login_layout">
            <div className="layout-box">
                <div className="half white-half">
                    <div className="innerbox">
                        <div className="inner-box">
                            <img src={updateIllustration} alt="Update Illustration" className="inner-image" />
                            <p className="inner-text">Securely update your password</p>
                            <p className="inner-description">
                                Set a new password to secure your account.
                            </p>
                        </div>

                    </div>
                </div>
                <div className="half gray-half">
                    <div className='icon_center'>
                        <img src={bugtrack} alt="Vulnytics" className="bugtrack-image"></img>
                    </div>
                    <div className="gray-inner-box">
                        <h2 className="form-heading">Update your password</h2>
                        {isValid ? (
                            <>
                                <div className="update-input-group">
                                    <Icon icon="bi:key-fill" className="input-icon1" />
                                    <input
                                        type={passwordVisible1 ? 'text' : 'password'}
                                        placeholder="New Password"
                                        className="form-input password-input"
                                        value={newPassword}
                                        onChange={(e) => {
                                            setNewPassword(e.target.value);
                                            setNewPasswordError('');
                                        }}
                                    />
                                    <FontAwesomeIcon
                                        icon={passwordVisible1 ? faEye : faEyeSlash}
                                        onClick={togglePasswordVisibility1}
                                        className='eye_icon'
                                    />
                                    {newPasswordError && <p style={{color:"red"}}>{newPasswordError}</p>}

                                </div>
                                <div className="update-input-group">
                                    <Icon icon="bi:key-fill" className="input_passowrd_icon" />
                                    <input
                                        type={passwordVisible2 ? 'text' : 'password'}
                                        placeholder="Confirm Password"
                                        className="form-input password-input"
                                        value={confirmPassword}
                                        onChange={(e) => {
                                            setConfirmPassword(e.target.value);
                                            setConfirmPasswordError('');
                                        }}
                                    />
                                    <FontAwesomeIcon
                                        icon={passwordVisible2 ? faEye : faEyeSlash}
                                        onClick={togglePasswordVisibility2}
                                        className='eye_icon'
                                    />
                                    {confirmPasswordError && <p style={{ color: 'red'}}>{confirmPasswordError}</p>}
                                </div>
                                <div>
                                    <button className="update-button" onClick={handlePassword}>Update password</button>

                                </div>
                            </>
                        ) : (
                            <div className='update-error_message'>
                                <p>Invalid request or resource requested could not be found on this server.</p>
                            </div>
                        )}

                    </div>
                </div>
            </div>
            <div className='loginpage_copyright'>
                <p>© 2026, ISECURION Technology and Consulting Pvt. Ltd, All Rights Reserved.</p>
            </div>
        </div>
    )
}

export default UpdateUser;
